"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poweredByAmazonWidget = poweredByAmazonWidget;
var _constants = require("../../../constants/constants");
var _utils = require("../../../utils/utils");
function generatePoweredByAmazonUrl() {
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.POWERED_BY_AMAZON, {});
}
function poweredByAmazonWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, generatePoweredByAmazonUrl());
}
//# sourceMappingURL=bwa-powered-by-amazon.js.map
